module.exports = __webpack_public_path__ + "vehicle-image-not-available.aa28840d0c5f547224f8.png";